import { render } from "./MenuSuperior.vue?vue&type=template&id=300b1205"
import script from "./MenuSuperior.vue?vue&type=script&lang=js"
export * from "./MenuSuperior.vue?vue&type=script&lang=js"

import "./MenuSuperior.vue?vue&type=style&index=0&id=300b1205&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__